import { useQuery } from '@apollo/client';
import { TEAMPERMISSIONS_USER_RESOURCES_QUERY } from '@/graphql/queries';

const useTeampermissionsUserResources = ({
  permissions = 'edit_content',
} = {}) => {
  const variables = { permissions };
  const { error, ...rest } = useQuery(TEAMPERMISSIONS_USER_RESOURCES_QUERY, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useTeampermissionsUserResources };
